import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Slide,
  CircularProgress,
} from '@mui/material';
import {
  Refresh as RefreshIcon,
  SystemUpdate as SystemUpdateIcon,
} from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const VersionUpdateDialog = ({ open, onReload }) => {
  const [isReloading, setIsReloading] = React.useState(false);

  const handleReloadClick = () => {
    setIsReloading(true);
    // App.js에서 전달된 onReload 호출
    setTimeout(() => {
      onReload();
    }, 300);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      }}
      fullWidth
      maxWidth="sm"
      BackdropProps={{
        style: { backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: 1399 },
      }}
      PaperProps={{
        sx: {
          zIndex: 1400,
          borderRadius: '16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          background: 'linear-gradient(135deg, #008b43 0%, #00b557 100%)',
          color: '#fff',
          padding: '24px',
          textAlign: 'center',
        }}
      >
        <SystemUpdateIcon
          sx={{
            fontSize: '64px',
            marginBottom: '16px',
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%, 100%': { transform: 'scale(1)', opacity: 1 },
              '50%': { transform: 'scale(1.1)', opacity: 0.8 },
            },
          }}
        />
        <DialogTitle
          sx={{
            color: '#fff',
            fontSize: '24px',
            fontWeight: 'bold',
            padding: 0,
            marginBottom: '8px',
          }}
        >
          새로운 버전이 배포되었습니다
        </DialogTitle>
      </Box>

      <DialogContent sx={{ padding: '32px 24px', textAlign: 'center' }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: '16px',
            color: '#333',
            lineHeight: 1.6,
            marginBottom: '16px',
          }}
        >
          최신 버전의 애플리케이션을 사용하시려면
          <br />
          페이지를 새로고침해주세요.
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontSize: '14px', color: '#666', marginTop: '8px' }}
        >
          새로고침하지 않으면 일부 기능이 정상적으로 작동하지 않을 수 있습니다.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{ padding: '20px 24px', justifyContent: 'center', gap: '12px' }}
      >
        <Button
          onClick={handleReloadClick}
          variant="contained"
          color="primary"
          size="large"
          disabled={isReloading}
          startIcon={
            isReloading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <RefreshIcon />
            )
          }
          sx={{
            minWidth: '200px',
            height: '48px',
            fontSize: '16px',
            fontWeight: 'bold',
            borderRadius: '8px',
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(0, 139, 67, 0.3)',
            '&:hover': {
              boxShadow: '0 6px 16px rgba(0, 139, 67, 0.4)',
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          {isReloading ? '새로고침 중...' : '지금 새로고침'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionUpdateDialog;
